export default __webpack_public_path__ + "static/media/sportsCommunityBadgeDowmloadAble.2b85bbd0.png";